module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_05-4c40c52cd13ad1d0756d09694b52bcf1.jpg";